<template>
    <div>
      <router-link
          class="action"
          :class="{'premium': subscription_plan.premium}"
          :to="{ name: 'subscribe', query: { plan: subscription_plan.id } }"
      >
        <div class="icon"></div>
        <div class="description">
          <template
            v-if="subscription_plan.premium"
          >
            <span>
              {{ $t('webstars.buttons.premium.title', { currency_symbol: 'U$', amount: subscription_plan.amount }) }}
            </span>
              <small>
              {{ $t('webstars.buttons.premium.subtitle') }}
            </small>
          </template>
          <template
            v-else
          >
            <span>
              {{ $t('webstars.buttons.normal.title', { currency_symbol: 'U$', amount: subscription_plan.amount }) }}
            </span>
              <small>
              {{ $t('webstars.buttons.normal.subtitle') }}
            </small>
          </template>
        </div>
      </router-link>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
      subscription_plan: {
            type: Object,
            required: true
        },
    },
    data(){
        return {
        };
    },
    methods: {
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.action{
  display: flex;
  width: 300px;
  height: 50px;
  border-radius: 15px;
  text-align: center;
  background: #cccccc;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  font-weight: bold;
  
  .icon {
    width: 80px;
    height: 50px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("/img/btn/btn-normal.png");
  }

  .description {
    width: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    
    small{
      font-size: .6em;
    }
  }
  
  &.premium {
    .icon {
      background-image: url("/img/btn/btn-premium.png");
    }
    .description {}
  }
}
</style>